import { createSlice } from '@reduxjs/toolkit';

export const defaultLocation = {
  zoom: null,
  center: null,
  bounds: [
    // Bounds for continental US
    23.924195828920954, // South
    51.01250390833167, // North
    -126.92197645479062, // West
    -64.82724989229064, // East
  ],
};

export const initialState = {
  ...defaultLocation,
  forceFetchAfterFitBounds: false,
  isLoading: false,
  message: 'Loading...',
  messages: [],
  keys: [],
  dropDownGeoType: '',
  shapesGeoType: null,
  shapesData: [],
  shapes: [],
  selectedShapeId: null,
  mapType: 'roadmap',
  selectedShapeFilter: {
    filterValueLow: '',
    filterValueHigh: '',
  },
  shapesColoringType: 'MedianIncome',
  colorPaletteId: 'yellowToBlue',
  colorPalettes: [
    {
      id: 'shapeDefault',
      c0: '#dd514cbb',
      c1: '#fdc980bb',
      c2: '#5eb95ebb',
    },
    {
      id: 'yellowToBlue',
      c0: '#ecec37dd',
      c1: '#90e0dddd',
      c2: '#5986d6dd',
    },
    {
      id: 'whiteToBlue',
      c0: '#e0efffdd',
      c1: '#71c0fddd',
      c2: '#0a93ffdd',
    },
    {
      id: 'blueToPurple',
      c0: '#00c4df80',
      c1: '#0024dd80',
      c2: '#d600df80',
    },
    {
      id: 'whiteToOrange',
      c0: '#ffe7c9dd',
      c1: '#ffc57cdd',
      c2: '#ffa129dd',
    },
    {
      id: 'blueToGreen',
      c0: '#68a4ffbb',
      c1: '#5dce9cbb',
      c2: '#2bac31bb',
    },
  ],
};

const slice = createSlice({
  name: 'assumptionMapSlice',
  initialState,
  reducers: {
    setMapLocation: {
      reducer: (state, action) => {
        const { location, forceFetchAfterFitBounds } = action.payload;
        return {
          ...state,
          zoom: location.hasOwnProperty('zoom') ? location.zoom : state.zoom,
          center: location.hasOwnProperty('center')
            ? location.center
            : state.center,
          bounds: location.hasOwnProperty('bounds')
            ? location.bounds
            : state.bounds,
          forceFetchAfterFitBounds,
        };
      },
      prepare: (
        location,
        shouldFetch = true,
        forceFetchAfterFitBounds = false
      ) => ({ payload: { location, shouldFetch, forceFetchAfterFitBounds } }),
    },
    setMapIsLoading: {
      reducer: (state, action) => {
        const { keys, messages } = state;
        const { payload } = action;
        const loadingIndex = state.keys.indexOf(payload.key);
        if (payload.isLoading) {
          if (loadingIndex > -1) {
            keys[loadingIndex] = payload.key;
            messages[loadingIndex] = payload.message;
          } else {
            keys.push(payload.key);
            messages.push(payload.message);
          }
        } else {
          if (loadingIndex > -1) {
            keys.splice(loadingIndex, 1);
            messages.splice(loadingIndex, 1);
          }
        }
        state.isLoading = messages.length > 0;
        state.message = messages[0] ?? '';
      },
      prepare: (isLoading, key, message = '') => ({
        payload: { isLoading, key, message },
      }),
    },
    setSelectedShapeId: (state, action) => {
      state.selectedShapeId = action.payload;
    },
    setShapesData: (state, action) => {
      state.shapesData = action.payload;
    },
    setDropDownGeoType: (state, action) => {
      state.dropDownGeoType = action.payload;
    },
    setShapesGeoType: (state, action) => {
      state.shapesGeoType = action.payload;
    },
    setShapes: (state, action) => {
      state.shapes = action.payload;
    },
    setColorPaletteId: (state, action) => {
      state.colorPaletteId = action.payload;
    },
    setShapesColoringType: (state, action) => {
      state.shapesColoringType = action.payload;
    },
    setMapType: (state, action) => {
      state.mapType = action.payload;
    },
    setSelectedShapeFilter: (state, action) => {
      state.selectedShapeFilter = action.payload;
    },
  },
});

export const assumptionMapActions = slice.actions;
export default slice.reducer;
